import { memo } from 'react';

import KnowledgeIconSVG from '@/assets/knowledge-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IKnowledgeIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={KnowledgeIconSVG} {...props} />;

export const KnowledgeIcon = memo(IKnowledgeIcon) as typeof IKnowledgeIcon;
